import { ImageFeedConfigBlockState } from './types';

const DefaultState: ImageFeedConfigBlockState = {
    settings: {
        fontSize: 11,
    },
    databilities: [
        {
            id: 'superDuperUnique1',
            datasetId: '',
            capabilityId: 'specden',
        },
    ],
};

export default DefaultState;
